<script lang="ts" setup>
  import { XMarkIcon } from '@heroicons/vue/24/outline'
  import { useI18n } from 'vue-i18n'

  defineProps<{
    icon?: string
    text: string
    cta?: string
  }>()

  const emit = defineEmits<{
    (e: 'cta'): void
    (e: 'dismiss'): void
  }>()

  const { t } = useI18n({ useScope: 'global' })
</script>

<template>
  <div
    role="status"
    class="bg-base-100 border-base-300 flex items-center gap-2 border-b px-3 py-1.5 text-sm print:hidden"
  >
    <span
      v-if="icon"
      :class="`icon-[${icon}] size-4 shrink-0 opacity-60`"
      aria-hidden="true"
    ></span>
    <span class="text-base-content/80 flex-1">{{ text }}</span>
    <button
      v-if="cta"
      type="button"
      class="btn btn-xs btn-ghost text-primary"
      @click="emit('cta')"
    >
      {{ cta }}
    </button>
    <button
      type="button"
      class="btn btn-xs btn-ghost btn-circle opacity-60 hover:opacity-100"
      :aria-label="t('onboarding.nudges.dismiss')"
      @click="emit('dismiss')"
    >
      <XMarkIcon class="size-4" />
    </button>
  </div>
</template>
